import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import Icon from '../Icon'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const _Icon = styled(Icon)`
  height: 100%;
  width: 100%;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  @media ${mq(sizes.tablet)} {
  }
`
